// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import GitHubIcon from "@mui/icons-material/GitHub";
import YouTubeIcon from "@mui/icons-material/YouTube";

// Material Kit 2 React components
import MKTypography from "components/MKTypography";

// Images
import logoCT from "assets/images/logo.png";

const date = new Date().getFullYear();

export default {
  brand: {
    name: "AF1985Inc",
    image: logoCT,
    route: "/",
  },
  socials: [
    {
      icon: <FacebookIcon />,
      link: "https://www.facebook.com//",
    },
    {
      icon: <TwitterIcon />,
      link: "https://twitter.com/",
    },

    {
      icon: <YouTubeIcon />,
      link: "https://www.youtube.com/channel/UCVyTG4sCw-rOvB9oHkzZD1w",
    },
  ],
  menus: [
    {
      name: "ABOUT",
      items: [
        { name: "Who We Are", href: "/pages/about-us/who-we-are" },
        { name: "Team", href: "/pages/about-us/team" },
        { name: "Awards", href: "/pages/about-us/values-and-commitment" },
      ],
    },
    {
      name: "Our Expertise",
      items: [
        {
          name: "Dynamic Student Housing",
          href: "/pages/expertise/dynamic-student-housing",
        },
        {
          name: "Residential and Multi-Family Communities",
          href: "/pages/expertise/residential-and-multi-family-communities",
        },
        {
          name: "Powerful Public-Private Partnerships",
          href: "/pages/expertise/powerful-public-private-partnerships",
        },
        {
          name: "Premier Corporate Headquarters and Office Buildings",
          href: "/pages/expertise/premier-corporate-headquarters-and-office-buildings",
        },
        {
          name: "Thriving Mixed-Use Developments",
          href: "/pages/expertise/thriving-mixed-use-developments",
        },
        {
          name: "Efficient Distribution and Logistic Centers",
          href: "/pages/expertise/efficient-distribution-and-logistic-centers",
        },
        {
          name: "Enhanced Public Facilities",
          href: "/pages/expertise/enhanced-public-facilities",
        },
      ],
    },
    {
      name: "help & support",
      items: [
        {
          name: "contact us",
          href: "/pages/contact/message",
        },
        {
          name: "US Office",
          href: "/pages/contact/us-office",
        },
        {
          name: "Lagos Office",
          href: "/pages/contact/lagos-office",
        },
      ],
    },
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      All rights reserved. Copyright &copy; {date} by{" "}
      <MKTypography
        component="a"
        href="https://www.creative-tim.com"
        target="_blank"
        rel="noreferrer"
        variant="button"
        fontWeight="regular"
      >
        Ocean Blue Tech
      </MKTypography>
      .
    </MKTypography>
  ),
};
